module.exports = __webpack_public_path__ + "static/media/PSLxTextItalic.3c023bba.ttf";